import { z } from 'zod/v4';
import { TodoType } from '../../workflows/index.js';
import { ToolCategory, ToolName, ToolPolicy, ToolWeight } from '../types.js';
const inputSchema = z.object({
    updateTypeId: z
        .uuid()
        .describe('The update type to fetch. Obtain via search_update_types — do not invent ids.'),
});
const outputSchema = z.object({
    updateTypeId: z.uuid(),
    label: z.string(),
    description: z.string(),
    selectable: z.boolean(),
    pausing: z.boolean(),
    important: z.boolean(),
    procedure: z.array(z.object({
        todoType: z.enum(TodoType),
        summary: z.string(),
    })),
});
export const getUpdateTypeTool = {
    name: ToolName.GetUpdateType,
    category: ToolCategory.CaseManagement,
    weight: ToolWeight.Light,
    version: 2,
    defaultPolicy: ToolPolicy.AutoRun,
    llmDescription: 'Read full details of an update type, including whether it is selectable and the procedure it triggers when applied. A non-selectable type must not be chosen unless the current TASK or TENANT GUIDANCE explicitly requests that exact type. Use this before proposing create_update if you want to understand the cascading effects of applying a particular type.',
    inputSchema,
    outputSchema,
};
//# sourceMappingURL=get-update-type.js.map